var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6869 12.4628C15.6869 14.4428 14.0869 16.0428 12.1069 16.0428C10.1269 16.0428 8.52686 14.4428 8.52686 12.4628C8.52686 10.4828 10.1269 8.88281 12.1069 8.88281C14.0869 8.88281 15.6869 10.4828 15.6869 12.4628Z",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1068 20.7331C15.6368 20.7331 19.6767 18.6531 21.9667 15.0531C22.8667 13.6431 22.8667 11.2731 21.9667 9.8631C19.6767 6.2631 15.6368 4.18311 12.1068 4.18311C8.5768 4.18311 4.5369 6.2631 2.2469 9.8631C1.3469 11.2731 1.3469 13.6431 2.2469 15.0531C4.5369 18.6531 8.5768 20.7331 12.1068 20.7331Z",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.929b0dc2.svg";
export { ForwardRef as ReactComponent };